import { memo } from "react";
import "Components/ConfigLayout/ConfigLayout.less";
import ConfigNav from "Components/ConfigLayout/ConfigNav";
import { Outlet } from "react-router-dom";
import { SettingsLayout } from "@clintonelec/react-storybook";

function ConfigLayout() {
	return (
		<SettingsLayout>
			<ConfigNav />
			<SettingsLayout.Content>
				<Outlet />
			</SettingsLayout.Content>
		</SettingsLayout>
	);
}

export default memo(ConfigLayout);
